import { apiCall, API_CONFIG } from './api';

const buildDriverPayload = (payload = {}) => {
  const hasFile = payload.profilePictureFile instanceof File;

  if (!hasFile) {
    const jsonPayload = { ...payload };
    delete jsonPayload.profilePictureFile;
    delete jsonPayload.profilePicture;
    return jsonPayload;
  }

  const formData = new FormData();
  formData.append('name', payload.name || '');
  formData.append('phoneNumber', payload.phoneNumber || '');
  formData.append('color', payload.color || '#FE8403');
  formData.append('status', String(payload.status !== false));
  formData.append('profilePicture', payload.profilePictureFile);
  
  if (payload.earningType !== undefined && payload.earningType !== null) {
    formData.append('earningType', payload.earningType);
  }
  if (payload.commission !== undefined && payload.commission !== null) {
    formData.append('commission', String(payload.commission));
  }
  if (payload.overtime !== undefined && payload.overtime !== null) {
    formData.append('overtime', String(payload.overtime));
  }
  if (payload.type) {
    formData.append('type', payload.type);
  }
  if (payload.isExpressDriver !== undefined && payload.isExpressDriver !== null) {
    formData.append('isExpressDriver', String(payload.isExpressDriver === true));
  }

  return formData;
};

export const driverAPI = {
  getAllDrivers: async (type = 'delivery') => {
    try {
      const url = `${API_CONFIG.ENDPOINTS.DRIVERS_LIST}?type=${type}`;
      const response = await apiCall(url, {
        method: 'GET',
      });

      if (response.success) {
        return {
          success: true,
          data: response.data,
          msg: response.msg
        };
      }

      return {
        success: false,
        error: response.msg || 'Failed to fetch drivers'
      };
    } catch (error) {
      console.error('Fetch drivers error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.'
      };
    }
  },

  requestLocation: async () => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.DRIVERS_REQUEST_LOCATION, {
        method: 'POST',
      });

      if (response.success) {
        return { success: true, msg: response.msg };
      }

      return { success: false, error: response.msg || 'Failed to request location' };
    } catch (error) {
      console.error('Request location error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.'
      };
    }
  },

  addDriver: async (payload) => {
    try {
      const requestBody = buildDriverPayload(payload);
      const response = await apiCall(API_CONFIG.ENDPOINTS.DRIVERS_ADD, {
        method: 'POST',
        body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return { success: false, error: response.msg || response.error || 'Failed to add driver' };
    } catch (error) {
      console.error('Add driver error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.'
      };
    }
  },

  updateDriver: async (driverId, payload) => {
    try {
      const requestBody = buildDriverPayload(payload);
      const response = await apiCall(`${API_CONFIG.ENDPOINTS.DRIVERS_UPDATE}/${driverId}`, {
        method: 'PUT',
        body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return { success: false, error: response.msg || response.error || 'Failed to update driver' };
    } catch (error) {
      console.error('Update driver error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.'
      };
    }
  },

  deleteDriver: async (driverId) => {
    try {
      const response = await apiCall(`${API_CONFIG.ENDPOINTS.DRIVERS_DELETE}/${driverId}`, {
        method: 'DELETE',
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return { success: false, error: response.msg || response.error || 'Failed to delete driver' };
    } catch (error) {
      console.error('Delete driver error:', error);
      return {
        success: false,
        error: 'Network error. Please try again.'
      };
    }
  },
};
